export default "__VITE_ASSET__BeDfdYTi__"